export type WorkflowType = 'selected_amount' | 'with_buffer' | 'price_limit';

export type BufferAmountSettingJson = {
  domestic_hotel_under_regulation_workflow_type?: WorkflowType;
  domestic_hotel_under_regulation_buffer_amount?: number;
  domestic_hotel_over_regulation_workflow_type?: WorkflowType;
  domestic_hotel_over_regulation_buffer_amount?: number;
  foreign_hotel_under_regulation_workflow_type?: WorkflowType;
  foreign_hotel_under_regulation_buffer_amount?: number;
  foreign_hotel_over_regulation_workflow_type?: WorkflowType;
  foreign_hotel_over_regulation_buffer_amount?: number;
  domestic_flight_workflow_type?: WorkflowType;
  domestic_flight_buffer_amount?: number;
  foreign_flight_workflow_type?: WorkflowType;
  foreign_flight_buffer_amount?: number;
  package_workflow_type?: WorkflowType;
  package_buffer_amount?: number;
};

class BufferAmountSetting {
  readonly domesticHotelUnderRegulationWorkflowType: WorkflowType;
  readonly domesticHotelUnderRegulationBufferAmount: number;
  readonly domesticHotelOverRegulationWorkflowType: WorkflowType;
  readonly domesticHotelOverRegulationBufferAmount: number;
  readonly foreignHotelUnderRegulationWorkflowType: WorkflowType;
  readonly foreignHotelUnderRegulationBufferAmount: number;
  readonly foreignHotelOverRegulationWorkflowType: WorkflowType;
  readonly foreignHotelOverRegulationBufferAmount: number;
  readonly domesticFlightWorkflowType: WorkflowType;
  readonly domesticFlightBufferAmount: number;
  readonly foreignFlightWorkflowType: WorkflowType;
  readonly foreignFlightBufferAmount: number;
  readonly packageWorkflowType: WorkflowType;
  readonly packageBufferAmount: number;

  constructor(args: BufferAmountSettingJson) {
    this.domesticHotelUnderRegulationWorkflowType =
      args.domestic_hotel_under_regulation_workflow_type || 'selected_amount';
    this.domesticHotelUnderRegulationBufferAmount = args.domestic_hotel_under_regulation_buffer_amount || 0;
    this.domesticHotelOverRegulationWorkflowType =
      args.domestic_hotel_over_regulation_workflow_type || 'selected_amount';
    this.domesticHotelOverRegulationBufferAmount = args.domestic_hotel_over_regulation_buffer_amount || 0;
    this.foreignHotelUnderRegulationWorkflowType =
      args.foreign_hotel_under_regulation_workflow_type || 'selected_amount';
    this.foreignHotelUnderRegulationBufferAmount = args.foreign_hotel_under_regulation_buffer_amount || 0;
    this.foreignHotelOverRegulationWorkflowType =
      args.foreign_hotel_over_regulation_workflow_type || 'selected_amount';
    this.foreignHotelOverRegulationBufferAmount = args.foreign_hotel_over_regulation_buffer_amount || 0;
    this.domesticFlightWorkflowType = args.domestic_flight_workflow_type || 'selected_amount';
    this.domesticFlightBufferAmount = args.domestic_flight_buffer_amount || 0;
    this.foreignFlightWorkflowType = args.foreign_flight_workflow_type || 'selected_amount';
    this.foreignFlightBufferAmount = args.foreign_flight_buffer_amount || 0;
    this.packageWorkflowType = args.package_workflow_type || 'selected_amount';
    this.packageBufferAmount = args.package_buffer_amount || 0;
  }

  getDomesticHotelBufferAmount(isOverRegulation: boolean, hotelPriceLimit: number, price: number): number {
    if (isOverRegulation) {
      return this.domesticHotelOverRegulationWorkflowType === 'with_buffer'
        ? this.domesticHotelOverRegulationBufferAmount
        : 0;
    }

    return this.domesticHotelUnderRegulationWorkflowType === 'with_buffer'
      ? this.domesticHotelUnderRegulationBufferAmount
      : this.domesticHotelUnderRegulationWorkflowType === 'price_limit'
      ? Math.max(hotelPriceLimit - price, 0)
      : 0;
  }

  getForeignHotelBufferAmount(isOverRegulation: boolean, hotelPriceLimit: number, price: number): number {
    if (isOverRegulation) {
      return this.foreignHotelOverRegulationWorkflowType === 'with_buffer'
        ? this.foreignHotelOverRegulationBufferAmount
        : 0;
    }

    return this.foreignHotelUnderRegulationWorkflowType === 'with_buffer'
      ? this.foreignHotelUnderRegulationBufferAmount
      : this.foreignHotelUnderRegulationWorkflowType === 'price_limit'
      ? Math.max(hotelPriceLimit - price, 0)
      : 0;
  }

  getDomesticFlightBufferAmount(): number {
    return this.domesticFlightWorkflowType === 'with_buffer' ? this.domesticFlightBufferAmount : 0;
  }

  getForeignFlightBufferAmount(): number {
    return this.foreignFlightWorkflowType === 'with_buffer' ? this.foreignFlightBufferAmount : 0;
  }

  getPackageBufferAmount(): number {
    return this.packageWorkflowType === 'with_buffer' ? this.packageBufferAmount : 0;
  }
}

export default BufferAmountSetting;
